const round = (value: number, decimals: number): number =>
  Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);

const roundForDisplay =
  (decimals: number, suffix = '') =>
  (value: number): string =>
    `${round(value, decimals)}${suffix}`;

const padNumberToDisplay = (value: number): string => {
  if (value < 0 && value > -10) {
    return `-0${Math.abs(value)}`;
  }
  if (value >= 0 && value < 10) {
    return `0${value}`;
  }
  return value.toString();
};

const groupForDisplay = (value: number, lang: string): string =>
  new Intl.NumberFormat(lang, { useGrouping: 'always' }).format(value);

const parseIntOr = <T>(value: string, defaultResult: T): number | T => {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return defaultResult;
  }
  return parsed;
};

const parseIntOrNull = (value: string | null | undefined): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  return parseIntOr(value, null);
};

export { round, roundForDisplay, groupForDisplay, padNumberToDisplay, parseIntOrNull };
